import { Component } from '@angular/core';
import { phoneFormatter } from '@shared/utils/phone-formatter';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: 'app-ag-phone-number',
  standalone: true,
  templateUrl: './ag-phone-number.component.html',
  styleUrl: './ag-phone-number.component.scss'
})
export class AgPhoneNumberComponent implements ICellRendererAngularComp {
  phone: string = '';

  agInit(params: ICellRendererParams): void {
    this.phone = phoneFormatter(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.phone = phoneFormatter(params);
    return true;
  }
}
